import MemberCardVue from '@/views/sm/member-search/member-search.vue';

const basePath = '/sm/member-search';
const role = 'sm'; // 角色身份

export const SM_MEMBER_SEARCH_INDEX = 'sm-member-search-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberCardVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_MEMBER_SEARCH_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "member-search" */
        `@/views/${role}/member-search/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
